<template>
	<div class="container">
		<div class="row">
			<div class="col-12 mt-5">
				<div class="row justify-content-center">
					<div class="col-12 text-center">
						<h1 class="fs-2 lh-1">Scrivi la tua nuova password</h1>
						<p>Deve avere almeno 8 caratteri</p>
					</div>

					<div class="col-lg-6 col-xl-4">
						<form id="change-password-request" @submit.prevent="onSubmitForm">
							<div class="row">
								<div class="col-12 mt-4">
									<p class="fs-1-2 bold mb-1">{{name}}</p>
								</div>
								<div class="col-12 form-group">
									<input type="email" name="e-mail" id="e-mail" class="form-control form-control-lg mb-0"  maxlength="150" v-model="mail" disabled>
								</div>

								<div class="col-12 form-group">
									<label class="fs-0-7 mb-0" for="password">Nuova password</label>
									<input type="password" name="password" id="password" class="form-control form-control-lg mb-0" required  autocomplete="aut_off_iuasdsvkz" maxlength="100" minlength="8" v-model="password">
								</div>

								<div class="col-12 form-group">
									<label class="fs-0-7 mb-0" for="retype-email">Per sicurezza, ripeti la nuova password</label>
									<input type="password" name="retype-password" id="retype-password" class="form-control form-control-lg mb-0" required  autocomplete="aut_off_iuasdsvkz" maxlength="100" minlength="8" v-model="retypePasseord">
								</div>

								<div class="col-12 form-group text-center mt-3">
									<input type="submit" id="sub-mail" class="btn btn-yellow rounded-pill btn-sm px-5" value="CONFERMA" :disabled="isBtnDisabled">
								</div>
								<div class="col-12 mb-5">
									<span v-html="formMsg"></span>
								</div>
							</div>
						</form>
					</div>

				</div>
			</div>
		</div>

			<!-- ** Modal ************************* -->
			<modal name="confirm-changes"
				height="auto"
				:adaptive=true
			>
				<div class="p-3">
					<div class="container" style="border-radius: 0.3rem">
						<div class="row">
							<div class="col-12 text-right pr-0">
								<svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" fill="#000000" class="bi bi-x hover-default" viewBox="0 0 16 16"  @click.prevent="hideModal">
									<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
								</svg>
							</div>
						</div>
						<div class="row">
							<div class="col-12 mb-3 text-center">
								<h3>Perfect!</h3>
								<p>La tua nuova password è stata salvata.</p>
								<p>Annotala per la prossima volta.</p>
							</div>
							<div class="col-12 text-center mb-4">
								<a :href="siteUrl" id="redirect-button" class="btn btn-yellow rounded-pill btn-sm px-3">VAI ALL’AREA RISERVATA</a>
							</div>
						</div>
					</div>
				</div>
			</modal>

	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'CangePasswordFormComponent',
	props: ['mail', 'codex', 'name'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			isBtnDisabled: false,
			formMsg: '',
			password: '',
			retypePasseord: '',
			siteUrl: ''
		}
	},

	methods: {
		onSubmitForm() {
			let url = this.ajaxObj.ajax_url
			this.isBtnDisabled = true
			this.formMsg = ''

			var data = new FormData();
			data.append('action', 'nl_change_wp_password')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('password', this.password)
			data.append('retypePassword', this.retypePasseord)
			data.append('key', this.codex)

			axios.post(url, data)
				.then((response) => {
					let _this = this
					// console.log(response.data)
					if(response.data.error == '') {
						// this.formMsg = response.data.msg
						this.siteUrl = response.data.site_url
						this.password = ''
						this.retypePasseord = ''
						_this.$modal.show('confirm-changes')
					} else {
						this.formMsg = '<span>' + response.data.error + '</span>'
					}
					this.isBtnDisabled = false
				}, (error) => {
					this.isBtnDisabled = false
					console.log(error);
				});
		},

		hideModal() {
			this.$modal.hide('confirm-changes');
			window.location.replace(this.siteUrl);
		}
	}
}
</script>
